import { ChildModel, ModelBase } from 'store/model-base';
import { SsmStatementSnapshot } from './ssm-statement-snapshot';

export interface SsmStatementYearGroup {
    yearGroup: string;
    statements: SsmStatementSnapshot[];
}

export class SsmStatementListV2 extends ModelBase {
    public static storeName: string = 'ssmStatementListV2';

    public header: string;
    public currentStatement: SsmStatementSnapshot;
    public olderStatements: SsmStatementSnapshot[];

    protected static get hasOne(): ChildModel[] {
        return [{
            attrName: 'currentStatement',
            model: SsmStatementSnapshot
        }];
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'olderStatements',
            model: SsmStatementSnapshot
        }];
    }

    public static groupStatementsByYear(statements: SsmStatementSnapshot[]): SsmStatementYearGroup[] {
        if (!statements?.length) {
            return [];
        }

        const groupedMap: Map<string, SsmStatementSnapshot[]> = new Map();

        statements.forEach((statement: SsmStatementSnapshot) => {
            const year: string = SsmStatementListV2.extractYearFromDate(statement.statementDate);
            if (!groupedMap.has(year)) {
                groupedMap.set(year, []);
            }
            groupedMap.get(year).push(statement);
        });

        return Array.from(groupedMap.entries()).map(([yearGroup, statementsGroup]: [string, SsmStatementSnapshot[]]) => ({
            yearGroup,
            statements: statementsGroup
        }));
    }

    private static extractYearFromDate(dateString: string): string {
        // Format expected: "Jan 24, 2026" or "DEC 24, 2025"
        const parts: string[] = dateString.split(', ');

        return parts.length > 1 ? parts[1].trim() : '';
    }
}
